import './wdyr';
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'formdata-polyfill';

import * as React from 'react';
import * as ReactDOM from 'react-dom';
// TODO to remove fabric css as we go
import 'office-ui-fabric-react/dist/css/fabric.min.css';
import { initializeIcons } from 'office-ui-fabric-react/lib/Icons';
import { createGlobalStyle } from 'styled-components';
import { getBaseTheme } from '@Themes';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';
import { AppProviders } from '@Context';

/* global Office */
let isOfficeInitialized = false;

const renderGlobalStyle = extraStylingNotInGlobal => {
    const GlobalStyle = createGlobalStyle([
        `${getBaseTheme().global.concat(extraStylingNotInGlobal || '')}`
    ]);
    return <GlobalStyle />;
};

// TODO to this theme provider for fabric as we go
const render = Component => {
    ReactDOM.render(
        <ErrorBoundary>
            <AppProviders>
                {renderGlobalStyle()}
                <Component isOfficeInitialized={isOfficeInitialized} />
            </AppProviders>
        </ErrorBoundary>,
        document.getElementById('container')
    );
};

/* Office initializes */
Office.initialize = () => {
    // Office js deletes window.history.pushState and window.history.replaceState. Restore them
    window.history.replaceState = window._historyCache.replaceState;
    window.history.pushState = window._historyCache.pushState;
};

/* Render application after Office initializes */
Office.onReady(() => {
    // Init fabric icons
    initializeIcons();

    // initialize && run the application
    isOfficeInitialized = true;
    // render app
    render(App);
});
